// Original transparent v2 artwork, arranged in five columns and two rows.
export const maritimeSpriteSize = { width: 1983, height: 793 };

// Visible pixel bounds in source order. Cropping in the viewBox preserves the
// supplied artwork while keeping each glyph centered at a consistent UI size.
export const maritimeIconBounds = {
  'ship only': [127, 156, 302, 316],
  'ship with water': [468, 154, 705, 343],
  'ship with coast': [801, 156, 1129, 343],
  'ship with sun': [1212, 112, 1514, 343],
  'ship on river': [1596, 160, 1916, 362],
  'ship with route': [73, 504, 381, 679],
  'ship at dock': [448, 504, 762, 680],
  'ship with destination': [820, 458, 1125, 684],
  'ship in lock': [1224, 474, 1501, 703],
  'dock': [1600, 534, 1911, 705],
};

export function maritimeIconViewBox(variant) {
  const [left, top, right, bottom] = maritimeIconBounds[variant] || maritimeIconBounds['ship only'];
  // Match Tabler's approximately 20/24 glyph-to-box ratio without distortion.
  const edge = (Math.max(right - left, bottom - top) + 1) * 1.2;
  return `${(left + right - edge) / 2} ${(top + bottom - edge) / 2} ${edge} ${edge}`;
}
